import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {TrailFilters} from "../../services/ngage/trail";

export default function useGetTrails(
  criteria: TrailFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['trails.all', criteria],
    () => ngage.trails.filtered(criteria),
    {enabled, keepPreviousData}
  );
}